import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MessageService } from '@mctic/ng-core';
import { ModalConfirmacaoComponent } from 'src/app/shared/modal-confirmacao';

@Component({
  selector: 'app-btn-cancelar',
  template: `
    <a (click)="cancelar()" color="warn" mat-stroked-button>
      Cancelar
    </a>
  `,
})
export class BtnCancelarComponent {

  @Input() mensagemModal = 'MSG003';
  @Output() eventoCancelar = new EventEmitter();

  constructor(
    private readonly dialog: MatDialog,
    private readonly messageService: MessageService,
  ) { }

  public cancelar() {
    const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
      width: '400px',
      data: {
        mensagem: this.messageService.findById('MSG003').description
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.eventoCancelar.emit();
      }
    });
  }

}
